module.exports = __webpack_public_path__ + "img/zhuansu1.gif";